module.exports = __webpack_public_path__ + "img/00045.0b9ceb94.webp";